module.exports = __webpack_public_path__ + "img/edit-self.06aecfd7.svg";